<template>
    <div class="home-page-root">

        <el-carousel height="550px">
           <!-- <el-carousel-item>
                <div class="xe-slider-item-img"
                    style="background-image:url(../../static/img/banner3.jpg); background-repeat: round;background-size: cover;height: 100%;width: 100%;">
                </div>
            </el-carousel-item> -->

            <el-carousel-item>
                <div class="xe-slider-item-img"
                    style="background-image:url(../../static/img/banner.jpg); background-repeat: round;background-size: cover;height: 100%;width: 100%;">
                </div>
            </el-carousel-item>
        </el-carousel>

        <!--   <div class="index-wrapper  swiper-box" style="margin: 0 auto;margin-top: 40px;">
            <div banner-id="0" class="banner">
                <div style="width: 100%;height: 100%;"
                    class="xe-slider swiper-container swiper-container-banner swiper-container-initialized swiper-container-horizontal">
                    <div class="main-part swiper-wrapper swiper-container4986473" style="transition-duration: 0ms; ">
                        <a class="xe-slider-item swiper-slide swiper-slide-duplicate swiper-slide-active"
                            data-swiper-slide-index="0" style="width: 100%;">
                            <div class="xe-slider-item-img"
                                style="background-image:url(../../static/img/1banner.jpg); background-repeat: round;background-size: cover;height: 100%;width: 100%;">
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div> -->

<!--       <div class="second-wrap">-->
<!--            <ul style="display: flex;justify-content: space-around;">-->
<!--&lt;!&ndash;                <li @click="zaixianshenbao"> <a class="certificate_box dis"> <em><img&ndash;&gt;-->
<!--&lt;!&ndash;                                src="../../static/img/zaixianshenbao.png" alt=""></em> <span>在线申报</span> </a> </li> &ndash;&gt;-->
<!--               &lt;!&ndash; <li @click="zhiyebiaozhun"> <a class="employment_box dis"><em><img-->
<!--                                src="../../static/img/zhiyebiaozhun.png" alt=""></em><span>职业标准</span> </a> </li>-->
<!--                <li @click="chengjicahxun"> <a class="practice_box dis"> <em><img-->
<!--                                src="../../static/img/chengjicahxun.png" alt=""></em> <span>成绩查询</span> </a> </li> &ndash;&gt;-->
<!--               &lt;!&ndash; <li @click="zhengshuchaxun"> <a class="read_box dis"> <em><img src="../../static/img/chengjicahxun.png"-->
<!--                                alt=""></em> <span>证书查询</span> </a>-->
<!--                </li> &ndash;&gt;-->
<!--            </ul>-->
<!--        </div>-->

<!--        <div class="wal index-news"-->
<!--            style="display: flex;justify-content: space-around;margin: 0 auto;margin-top: 40px;margin-bottom: 40px;">-->
<!--            <div class="col-1">-->
<!--                <div class="title"><a target="_blank"><em>通知公告</em><span>In the Media</span></a></div>-->
<!--                <div class="list">-->
<!--                    <ul>-->
<!--                        <li v-for="(item,index) in newsList1" :key="index" @click="detail(item)">-->
<!--                            <a>-->
<!--                                <div class="img"><img class="newsimg" v-if="index == 0" :src="item.contentPic"></div>-->
<!--                                <div class="name">{{item.contentTitle}}</div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="col-2" style="width: 644px;margin: 1px 60px;">-->
<!--                <div class="list swiper-container-horizontal">-->
<!--                    <ul class="swiper-wrapper">-->
<!--                        <li class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev"-->
<!--                            data-swiper-slide-index="2" style="width: 644px;">-->
<!--                            <div class="img"><a>-->
<!--                                    <img style="height: 369px;width: 644px;" class="newsimg" :src="news.contentPic"></a>-->
<!--                            </div>-->
<!--                            <a>-->
<!--                                <div class="title"><em>头条新闻</em><span>Headlines</span></div>-->
<!--                            </a>-->
<!--                            <div class="name" @click="detail(news)"><a>{{news.contentTitle}}</a></div>-->
<!--                            <p>-->
<!--                                {{news.contentDesc}}-->
<!--                            </p>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="col-1">-->
<!--                <div class="title"><a><em>新闻动态</em><span>Highlights</span></a> </div>-->
<!--                <div class="list">-->
<!--                    <ul>-->
<!--                        <li v-for="(item,index) in newsList2" :key="index" @click="detail(item)">-->
<!--                            <a>-->
<!--                                <div class="img"><img v-if="index == 0" class="newsimg" :src="item.contentPic"></div>-->


<!--                                <div class="name">{{item.contentTitle}}</div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </div>-->
<!--            </div>-->

<!--        </div>-->


        <!-- 通知公告 -->
        <!-- <div class="index-imgs" style="margin-top: 80px;">
            <div class="wal">
                <ul>
                    <li class="spwzzl" v-for="(item,index) in notification" :key="index">
                        <div class="box">
                            <div class="img ">
                                <a class="spwzz  spwz1"><img style="width: 433px;height: 223px;"
                                        :src="item.contentPic"></a>
                            </div>
                            <div class="name">
                                <a class="name" target="_blank"> {{item.contentTitle}}</a>
                            </div>
                        </div>

                    </li>
                </ul>
            </div>
        </div> -->




        <!-- 新闻/通知公告 （老版本） -->
        <!-- <div class="w-1200" style="width: 1300px;">
            <div class="layui-tab layui-tab-brief" style="padding-top: 15px" lay-filter="docDemoTabBrief">
                <ul class="layui-tab-title">
                    <li v-for="(item,index) in dataList" :key="index" style="font-size: 16px;"
                        :style="item.state === 2? 'border-bottom: 2px solid #5FB878;':''" @click="Handover(index)">
                        <a class="aa" :style="item.state === 2? 'font-weight: 600;color: #f58f00;':''">{{item.name}}</a>
                    </li>
                </ul>
                <div class="layui-tab-content  itemCon platform">
                    <div class="layui-tab-item layui-show new-notice-tongzhi">
                        <v-spin :spinning="loadingFlag" tip="正在读取数据." size="large" class="slideBoxa"
                            style="margin: 10px 0;">
                            <div class="bd">
                                <el-carousel :interval="500000" arrow="always">
                                    <el-carousel-item v-for="(item,index) in slideshowList1" :key="index">
                                        <img :src="item.src" :alt="item.contentTitle" :title="item.contentTitle"
                                            @error="imgerrorfun(index)" style="min-height: 240px;">
                                        <div class="tit" style="height: 50px;">
                                            <p @click="noticeDetail(item)"
                                                style="width: 350px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color:white;cursor: pointer;">
                                                {{item.contentTitle}}</p>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </v-spin>
                        <v-spin :spinning="loadingFlag" tip="正在读取数据." size="large" class="newscon"
                            style="width: 800px;">
                            <h2><a @click="detail()"
                                    style="white-space: nowrap;overflow: hidden;width: 400px;display: inline-block;text-overflow: ellipsis;">{{contentTitle}}</a>
                            </h2>
                            <p style="text-indent:2em;">{{str}}<a style="color:#f58f00;" @click="detail()">[详细]</a></p>
                            <ul>
                                <li class="ico" v-for="(item,index) in slideshowList" :key="index"
                                    @click="noticeDetail(item)">
                                    <a>{{item.contentTitle}}</a><span>[{{item.insertTime}}]</span>
                                </li>
                            </ul>
                        </v-spin>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- 职业标准  在线办理 -->
        <!-- <div id="service">
            <div class="w-1200" style="margin-bottom: 0px;width: 1300px;">
                <div class="item col3">
                    <div class="itemTit">
                        <h3 class="icoPlat" style="width: 125px;">职业标准</h3>
                        <a class="itemMore" @click="professionalStandardMore()">更多&gt;&gt;</a>
                    </div>
                </div>
                <div class="item-r col3">
                    <div class="itemTit">
                        <h3 class="icoPlat" style="width: 140px;">在线办理</h3>
                    </div>
                </div>

                <div class="item col3 item-module-zybz" data-id="32">
                    <div class="itemCon indexIntro" style="padding-top:10px;">
                        <div class="index_6_2_1_4" v-for="(item,index) in professionalStandardList" :key="index"
                            @click="noticeDetail(item)">
                            <div class="index_6_2_1_4_2" style="width: 100%;">
                                <h2>
                                    <a>{{item.contentTitle}}</a>
                                    <span style="float: right">[{{item.insertTime}}]</span>
                                </h2>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
                <div class="item-r col3">
                    <div class="index-haspadding">
                        <div class=" index-aligncenter index-wbmain">
                            <div class="index-imgmsg index-wbp1box" :class="netToFlag === true? 'index-av':''"
                                @click="netTo()">
                                <img class="index-wbp1" title="在线办理">
                            </div>
                            <div class="index-imgmsg index-wbp2box" :class="netToFlag === false? 'index-av':''"
                                @click="select()">
                                <img class="index-wbp2" title="业务查询">
                            </div>
                        </div>
                        <div class=" index-msgbox  index-aligncenter">
                            <div class="right_box overfy_sol other">
                                <ul class="overfy_sol clearF index-server1" v-if="netToFlag">
                                    <li class="box_info" v-for="(item,index) in wangbaoList" :key="index"
                                        @click="wangbao(item.level)">
                                        <a href="javascript:;" :title="item.title" class="jslevel"
                                            :class="item.className">
                                            <img class="index-show img-responsive" src="">
                                        </a>
                                    </li>
                                </ul>
                                <ul class="clearF index-server2" v-if="selectFlag">
                                    <li class="box_info" @click="scoreInquiry()">
                                        <a target="_blank" title="成绩查询" class="cjcx">
                                            <img class="index-show">
                                        </a>
                                    </li>
                                    <li class="box_info" @click="certificateInquiry()">
                                        <a target="_blank" title="证书查询" class="zscx">
                                            <img class="index-show">
                                        </a>
                                    </li>
                                    <li class="box_info">
                                        <a href="http://zybz.class.com.cn/" class="zybz" target="_blank"
                                            title="国家职业技能标准">
                                            <img class="index-show">
                                        </a>
                                    </li>
                                    <li class="box_info">
                                        <a href="http://www.mohrss.gov.cn/SYrlzyhshbzb/SYgundongxinwen/201710/t20171024_280005.html"
                                            class="zyml" target="_blank" title="职业资格目录">
                                            <img class="index-show">
                                        </a>
                                    </li>
                                    <li class="box_info">
                                        <a href="http://pjjg.osta.org.cn" target="_blank" title="技能人才信息平台" class="rcpt">
                                            <img class="index-show">
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div> -->
        <!-- <div class="link">
            <dt class="pageBT" style="padding-bottom:0px;">
                <p class="zh"><span>授权单位</span></p>
                <p class="en">Authorized Unit</p>
            </dt>
            <div class="md2018040401lty">
                <div class="container" id="containerList">
                    <div class="md-com-list">
                        <div class="md-hd">
                            <ul class="md-bd clearfix md-2018040201-lty">
                                <li v-for="(item,index) in authorizedUnitList" @click="containerDetail(item)"
                                    class="pic-box pic-box-g pull-left live">
                                    <div class="hd-pic"><a target="_blank"><img
                                                src="../../static/img/authorization.png"> </a></div>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- 友情链接 -->
        <div class="link">
            <dt class="pageBT" style="padding-bottom:0px;">
                <p class="zh"><span>友情链接</span></p>
                <p class="en">Friendly Link</p>
            </dt>
            <div class="mian" style="width: 80%;">
                <ul style="padding:20px 0;width:100%;margin: 0 auto;display: flex;justify-content: space-evenly;">
                    <li style="line-height: 30px;"><a title="中国人力资源和社会保障部" target="_blank"
                            href="http://www.mohrss.gov.cn/">中国人力资源和社会保障部</a></li>
                    <li style="line-height: 30px;"><a title="山西省人力资源和社会保障厅" target="_blank"
                            href="http://rst.shanxi.gov.cn/">山西省人力资源和社会保障厅</a></li>
                    <li style="line-height: 30px;"><a title="中国就业网" target="_blank"
                            href="http://chinajob.mohrss.gov.cn/">中国就业网</a></li>
                    <li style="line-height: 30px;"><a title="山西就业网" target="_blank"
                            href="http://chinajob.mohrss.gov.cn/">山西就业网</a></li>
                    <li style="line-height: 30px;"><a title="中国就业培训指导中心" target="_blank"
                            href="http://www.cettic.gov.cn/">中国就业培训指导中心</a></li>
                    <li style="line-height: 30px;"><a title="世界技能大赛山西组委会官方网站" target="_blank"
                            href="http://www.worldskillschina.cn/">世界技能大赛山西组委会官方网站</a></li>
                </ul>
            </div>
        </div>


    </div>
</template>
<script>
    import Vue from 'vue'
    import vuebeauty from 'vue-beauty'
    import 'vue-beauty/package/style/vue-beauty.min.css'
    Vue.use(vuebeauty)
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                loadingFlag: false,
                id: 0,
                navName: '',
                wangbaoList: [{
                    title: '五级（初级工）',
                    className: 'js5',
                    level: 5
                },
                {
                    title: '四级（初级工）',
                    className: 'js4',
                    level: 4
                },
                {
                    title: '三级（初级工）',
                    className: 'js3',
                    level: 3
                },
                {
                    title: '技师',
                    className: 'js2',
                    level: 2
                },
                {
                    title: '高级技师',
                    className: 'js1',
                    level: 1
                }],
                netToFlag: true,
                selectFlag: false,
                dataList: [
                    {
                        name: '通知公告',
                        state: 2
                    },
                    {
                        name: '新闻中心',
                        state: 1
                    }
                ],
                slideshowList: [],
                str: '',
                contentTitle: '',
                professionalStandardList: [],
                flag: true,
                slideshowList1: [],
                authorizedUnitList: [],
                newsList1: [],
                newsList2: [],
                news: {},
                notification: []
            }
        },
        mounted() {
        },
        created() {
            //新闻
            this.newsDataLoad(28);


            //通知公告
            this.notificationDataLoad(29);
        },
        methods: {
            detail(item) {
                this.$router.push({ path: '/journalismNoticeDetail/' + item.id + "/" + item.navName })
            },
            zaixianshenbao() {

                if (this.$storage.get("declareUser") === undefined) {
                    this.$confirm('请先登录！').then(_ => {
                        this.$router.push('/login');
                    }).catch(_ => { });
                } else {
                    this.$router.push({ path: '/affirm/' + 3 + "/1" });
                }


            },
            zhiyebiaozhun() {
                this.$router.push("/journalismNotice/6")
            },
            chengjicahxun() {
                this.$router.push({ path: '/scoreInquire' })
            },
            zhengshuchaxun() {
                this.$router.push({ path: '/certificateInquire' })
            },
            //新闻
            newsDataLoad(navId) {
                //加载首页新闻列表
                let parames = new URLSearchParams();
                parames.append('navId', navId); //id 类型id
                parames.append('organStatus', this.organStatus);//  组织机构代码   1工大  2协会 3建投

                this.$axios.post(this.serverUrl + '/navList', parames).then(resp => {

                    if (resp.data.data.length > 0) {
                        let newsList1 = [];
                        let newsList2 = [];
                        resp.data.data.forEach((element, index) => {
                            element.contentPic = this.serverUrl + this.prefiexUrl + element.contentPic;
                            if (index <= 3) {

                                newsList1.push(element);

                            }

                            if (index > 4 && index <= 8) {
                                newsList2.push(element);
                            }

                            if (index == 4) {
                                element.contentDesc = this.cutstr(element.contentDesc, 340);
                                this.news = element
                            }
                        })

                        this.newsList1 = newsList1;
                        this.newsList2 = newsList2;


                        console.log(this.newsList1);
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙,请稍后再试!',
                        type: 'error'
                    })
                })
            },
            //通知公告
            notificationDataLoad(navId) {
                //加载首页新闻列表
                let parames = new URLSearchParams();
                parames.append('navId', navId); //id 类型id
                parames.append('organStatus', this.organStatus);//  组织机构代码   1工大  2协会 3建投

                this.$axios.post(this.serverUrl + '/navList', parames).then(resp => {

                    if (resp.data.data.length > 0) {
                        let notification = [];

                        resp.data.data.forEach((element, index) => {

                            if (index > 6 && index <= 12) {
                                element.contentPic = this.serverUrl + this.prefiexUrl + element.contentPic;
                                notification.push(element);

                            }
                        })

                        this.notification = notification;

                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙,请稍后再试!',
                        type: 'error'
                    })
                })
            },
            containerDetail(item) {

                this.$router.push({ path: '/journalismNoticeDetail/' + item.id + "/" + item.navName })

            },
            //职业标准 更多
            professionalStandardMore() {
                this.$router.push({ path: '/journalismNotice/6' })
            },
            scoreInquiry() {
                //成绩查询
                this.$router.push({ path: '/scoreInquire' })
            },
            certificateInquiry() {
                //证书查询
                this.$router.push({ path: '/certificateInquire' })
            },
            noticeDetail(item) {
                this.$router.push({ path: '/journalismNoticeDetail/' + item.id + "/" + item.navName })
            },
            imgerrorfun(index) {
                this.slideshowList[index].src = '../static/img/logo.png';
            },
            wangbao(level) {
                if (this.$storage.get('declareUser') != null && this.$storage.get('declareUser') != undefined) {
                    this.$router.push({ path: '/affirm/' + level + "/1" });
                } else {
                    this.$router.push({ path: '/login' });
                }
            },
            netTo() {
                this.netToFlag = true;
                this.selectFlag = false;
            },
            select() {
                this.netToFlag = false;
                this.selectFlag = true;
            },
            // 首页 通知公告 / 新闻中心 切换
            Handover(index) {
                this.dataList.forEach(element => {
                    if (element.state === 2) {
                        element.state = 1;
                    }
                });
                this.dataList[index].state = 2;


                this.flag = true;
                if (index === 0) {
                    this.HandoverNotificationOrPresscenterDataLoad(29);
                } else {
                    this.HandoverNotificationOrPresscenterDataLoad(28);
                }
            },
            cutstr(str, len) {
                var str = str.replace(/<[^>]+>/g, "").replace(/[ ]|[&nbsp;]/g, '');//去掉所有的html标记
                var str_length = 0;
                var str_len = 0;
                let str_cut = new String();

                for (var i = 0; i < str.length; i++) {
                    let a = str.charAt(i);
                    str_length++;
                    if (escape(a).length > 4) {
                        //中文字符的长度经编码之后大于4
                        str_length++;
                    }
                    str_cut = str_cut.concat(a);
                    if (str_length >= len) {
                        str_cut = str_cut.concat("...");
                        return str_cut;
                    }
                }

                //如果给定字符串小于指定长度，则返回源字符串；
                if (str_length < len) {
                    return str;
                }

            },

        }
    }
</script>

<style scoped>
    .home-page-root{
        position: static;
        top: 0;
        margin-top: 0;
    }
    .read_box {
        background: url(../../static/img/read_box.png) no-repeat;
    }

    .practice_box {
        background: url(../../static/img/practice_box.png) no-repeat;
    }

    .employment_box {
        background: url(../../static/img/employment_box.png) no-repeat;
    }

    .clearfix:after {
        content: '';
        display: block;
        height: 0;
        clear: both;
        overflow: hidden;
    }

    .second-wrap {
        width: 80%;
        margin: 0 auto;
        margin-top: 5%;
        margin-bottom: 5%;
    }



    .second-wrap span {
        font-size: 30px;
        color: #f7f7f7;
        display: inline-block;
        height: 60px;
        line-height: 60px;
        vertical-align: middle;
        font-weight: bold;
        margin-left: 15px;
    }

    .second-wrap em {
        width: 45px;
        height: 45px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 35px;
    }

    .dis {
        display: block;
    }

    .certificate_box {
        background: url(../../static/img/certificate_box.png) no-repeat;
    }

    .second-wrap a {
        padding: 30px;
        width: 290px;
        text-decoration: none;
    }

    .clearfix {
        display: block;
    }

    body,
    ul,
    ol,
    li,
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    form,
    fieldset,
    table,
    td,
    img,
    div,
    menu,
    dl,
    dt,
    dd,
    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nva,
    section {
        border: 0;
        padding: 0;
        margin: 0;
    }

    .index-news .col-2 .list li .title:before,
    .index-news .col-2 .list li .title:after {
        content: "";
        display: block;
        position: absolute;
        position: relative;
        width: 15px;
        height: 1px;
        background: #6510AD;
        opacity: 0.64;
        margin: 0 15px;
        top: 6px;
    }

    .index-news .col-2 .list li .title span {
        padding-left: 10px;
    }

    .justifyCenter,
    .index-flow .container .video i,
    .index-admissions .dots,
    .index-admissions .list dl,
    .index-news .col-2 .arrow .dots,
    .index-news .col-2 .list li .title,
    .index-flash .btn,
    .p-layer {
        justify-content: center;
        -webkit-justify-content: center;
    }

    .index-news .col-2 .list li .title {
        display: flex;
        color: #6510AD;
        font-size: 12px;
        padding-top: 22px;
        text-transform: uppercase;
        line-height: 1em;
    }

    .index-news .col-1 .title span {
        padding-left: 10px;
    }

    em {
        font-style: normal;
    }

    .index-news .col-1 .title a {
        color: #666;
    }

    .index-news .col-1 .title {
        font-size: 16px;
        text-transform: uppercase;
        color: #666;
        padding-top: 15px;
        line-height: 45px;
    }

    .newsimg:hover {
        transform: scale(1.2);
        transition: all 0.6s;
    }

    .index-news .col-2 .list li p {
        font-size: 13px;
        line-height: 22px;
        padding: 0 8px;
        color: #888;
    }

    .index-news .col-2 .list li p {
        text-align: left;
        text-indent: 2em;
    }

    .index-news .col-2 .list li .name a {
        display: block;
        font-size: 18px;
        line-height: 70px;
        color: #555;
        padding: 0.15rem 0.55rem 0.2rem 0.55rem;
    }

    .index-news .col-2 .list li .img {
        width: 644px;
        height: 396px;
        overflow: hidden;
        position: relative;
    }

    .swiper-slide {
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .index-news .col-2 .list li {
        text-align: center;
    }

    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-transition-property: -webkit-transform;
        -moz-transition-property: -moz-transform;
        -o-transition-property: -o-transform;
        -ms-transition-property: -ms-transform;
        transition-property: transform;
        -webkit-box-sizing: content-box;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
    }

    .index-news .col-2 .list {
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .index-news .col-2:before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border-left: #D6D6D6 solid 1px;
        border-right: #D6D6D6 solid 1px;
    }

    .index-news .col-2 {
        width: 6.71rem;
        position: relative;
        min-height: 7.2rem;
    }

    .index-news .col-1 li a .name {
        font-size: 15px;
        line-height: 30px;
        font-weight: bold;
        margin: 17px 0px;
    }

    .index-news .col-1 li a {
        display: block;
        color: #000;
    }

    .index-news .col-1 li a .img img {
        width: 268px;
        height: 150px;
    }

    .index-news .col-1 li a .img {
        width: 100%;
        overflow: hidden;
        position: relative;
        margin-bottom: -0.08rem;
    }

    .index-news .col-1 li a {
        display: block;
        color: #000;
    }

    li {
        list-style: outside none;
    }

    .index-news .col-1 li {
        border-bottom: #E2E2E2 solid 1px;
    }



    em {
        font-style: normal;
    }

    .index-news .col-1 .title a {
        color: #666;
    }

    .index-news .col-1 {
        width: 268px;
    }

    .wal {
        width: 80%;
        margin: 0 auto;
    }

    .index-imgs .box:hover .img img {
        transform: scale(1.2);
        transition: all 0.6s;
    }

    .index-imgs .box div.name a.name {
        display: block;
        color: #fff;
        font-size: 0.18rem;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 445px;
        height: 15px;
    }

    .index-imgs .box div.name .tag a {
        line-height: 0.26rem;
        padding: 0 0.1rem;
        font-size: 0.12rem;
        background: #791CB5;
        color: #fff;
    }

    .index-imgs .box div.name .tag {
        padding-bottom: 0.12rem;
    }

    .index-imgs .box div.name {
        position: absolute;
        z-index: 1;
        left: 0.39rem;
        right: 0.49rem;
        top: auto;
        bottom: 0.3rem;
    }

    img {
        vertical-align: middle;
        max-width: 100%;
        border: 0;
    }

    .index-imgs .box .img a img {
        width: 100%;
    }

    .index-imgs .box .img a:before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: url(../../static/img/bg20.png) center bottom repeat-x;
        background-size: auto 2.01rem;
        z-index: 2;
    }

    .index-imgs .box .img a {
        width: 100%;
        overflow: hidden;
        position: relative;
        z-index: 1;
        display: block;
    }

    .index-imgs .box {
        position: relative;
    }

    li {
        list-style: outside none;
    }

    .index-imgs li {
        width: 33.333%;
    }

    .index-imgs ul,
    .index-news .wal,
    .index-flash .side ul {
        display: flex;
        display: -webkit-flex;
        display: -ms-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
    }

    .index-imgs {
        position: relative;
        z-index: 2;
    }


    body {
        font-size: 14px;
        color: #353535;
    }

    .index-wrapper .normal-goods-list .hot-list .hot-item:hover {
        color: #ff6000;
        font-size: 14px;
    }

    .item-tips {
        margin: 8px 0;
        display: flex;
        height: 18px;
        line-height: 18px;
        margin: 8px 0 16px;
    }

    .meta-box {
        position: absolute;
        bottom: 4px;
        left: 12px;
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .hot-item .item-title {
        height: 44px;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .hot-item .item-title.item-title__sp {
        display: block;
        height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .hot-list .item-footer {
        height: 30px !important;
    }

    .hot-item .item-footer {
        padding: 8px 12px 0;
        overflow: hidden;
        height: 126px;
    }

    .index-wrapper .normal-goods-list .hot-list .hot-item .item-footer {
        height: 84px;
        margin-bottom: 7px;
        position: relative;
    }

    .hot-item .item-img {
        width: 100%;
        height: 129px;
        vertical-align: top;
        border-radius: 4px;
        box-shadow: 0 0 4px #e6e6e6;
    }

    .hot-item {
        position: relative;
        width: 230px;
        height: 256px;
        border-radius: 4px;
        background: #fff;
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 1%), 0 6px 12px 0 rgb(0 0 0 / 6%);
        margin: 0 10px 10px 0;
        color: #353535;
        overflow: hidden;
        transition: transform .3s ease-in-out;
    }

    .index-wrapper .normal-goods-list .hot-list .hot-item {
        height: auto !important;
        margin: 0 12px 10px 0 !important;
    }

    .normal-goods-list .hot-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .mark-tip {
        display: inline-block;
        width: 4px;
        height: 22px;
        background: #ff6000;
        color: #ff6000;
        margin-right: 10px;
        border-radius: 2px;
        vertical-align: middle;
        margin-top: -2px !important;
    }

    .caption-module--title {
        height: 33px;
        font-size: 22px;
        color: #353535;
        line-height: 33px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 20px;
        margin-bottom: 0;
    }

    .caption-module {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        height: 33px;
        margin: 0 0 20px;
        background-color: transparent;
    }

    .normal-goods-list {
        width: 1300px;
    }

    .index .index-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .xe-slider .main-part {
        height: 100%;
        position: relative;
        display: flex;
        transition: all .3s linear;
    }

    /*  .xe-slider {
        height: 360px !important;
    } */

    .xe-slider,
    .xe-slider .main-part .xe-slider-item {
        width: 1200px;
    }

    .swiper-container {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
    }

    .banner,
    .banner-side {
        height: 500px !important;
    }

    .swiper-box {
        margin-bottom: 30px;
    }

    .index .index-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .md-2018040201-lty .pic-box:hover {
        box-shadow: 0 0px 20px 0px rgb(221 221 221);
        margin-top: 2px;
    }

    .md-com-list .md-hd {
        padding: 15px 0 15px;
        line-height: 27px;
        overflow: hidden;
    }

    .link ul {
        width: 100%;
        overflow: hidden;
        padding: 20px 0;
    }

    .clearfix {
        display: block;
        clear: both;
    }

    .md-2018040201-lty .pic-box .hd-pic img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
    }

    .md-19120602-xxw.live .state,
    .md-2018040201-lty .pic-box.live .state {
        display: block;
        background: url(../../static/img/authorization.png) no-repeat center center;
    }

    .md-19120602-xxw .state,
    .md-2018040201-lty .pic-box .state {
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 44px;
        z-index: 2;
        display: none;
    }

    .md-2018040201-lty .pic-box .hd-pic {
        height: 160px;
        position: relative;
    }

    .link li a {
        -moz-transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        color: #666;
    }

    .link li {
        float: left;
        font-size: 14px;
        line-height: 30px;
        width: auto;
        height: auto;
        float: left;
        margin: 0px 5px;
    }

    .md-2018040201-lty .pic-box {
        position: relative;
        transition: all .1s ease;
        overflow: hidden;
        width: 224px;
        margin: 0 10px;
        border-radius: 5px;
        margin-bottom: 20px;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1228px;
    }

    div /deep/ .el-carousel__indicators--horizontal {
        bottom: 5px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    a {
        color: black;
    }

    .aa :hover {
        color: #f58f00;
    }

    .el-carousel__indicators--horizontal {
        display: none;
        bottom: 20px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    .tit {
        height: 40px;
        position: absolute;
        line-height: 40px;
        width: 100%;
        bottom: 0;
        left: 0px;
        text-align: left;
        text-indent: 20px;
        border-radius: 0px;
        background: rgba(0, 0, 0, 0.6);
    }
</style>



// WEBPACK FOOTER //
// src/components/homePage.vue